import React, { createContext, useReducer } from 'react'
import { not } from 'ramda'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'

const DrawerContext = createContext()

const withDrawerProvider = (Component) =>
  function DrawerContextWrapper(props) {
    const [state, dispatch] = useReducer(reducer, initialState)
    const createAction = (action) => (payload) =>
      dispatch({ type: action, payload })

    const context = {
      ...state,
      setIsDrawerOpening: createAction(actionTypes.SET_DRAWER_OPENING),
      setIsDrawerOpened: createAction(actionTypes.SET_DRAWER_OPENED),
      setIsDrawerClosing: createAction(actionTypes.SET_DRAWER_CLOSING),
      setIsDrawerClosed: createAction(actionTypes.SET_DRAWER_CLOSED),
      setIsDrawerVisible: createAction(actionTypes.SET_DRAWER_VISIBLE),
      setShowDrawerMask: createAction(actionTypes.SET_SHOW_DRAWER_MASK),
      setDrawerWidth: createAction(actionTypes.SET_DRAWER_WIDTH),
    }

    return (
      <DrawerContext.Provider value={context}>
        <Component {...props} />
      </DrawerContext.Provider>
    )
  }

const initialState = {
  isDrawerOpening: false,
  isDrawerOpened: false,
  isDrawerClosing: false,
  isDrawerClosed: true,
  isDrawerVisible: false,
  showDrawerMask: false,
  drawerWidth: DEFAULT_DRAWER_WIDTH,
}

const actionTypes = {
  SET_DRAWER_OPENING: 'SET_DRAWER_OPENING',
  SET_DRAWER_OPENED: 'SET_DRAWER_OPENED',
  SET_DRAWER_CLOSING: 'SET_DRAWER_CLOSING',
  SET_DRAWER_CLOSED: 'SET_DRAWER_CLOSED',
  SET_DRAWER_VISIBLE: 'SET_DRAWER_VISIBLE',
  SET_SHOW_DRAWER_MASK: 'SET_SHOW_DRAWER_MASK',
  SET_DRAWER_WIDTH: 'SET_DRAWER_WIDTH',
}

const reducer = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_DRAWER_OPENING:
      return {
        ...state,
        isDrawerClosed: false,
        isDrawerOpening: true,
      }
    case actionTypes.SET_DRAWER_OPENED:
      return {
        ...state,
        isDrawerOpening: false,
        isDrawerOpened: true,
      }
    case actionTypes.SET_DRAWER_CLOSING:
      return {
        ...state,
        isDrawerOpened: false,
        isDrawerClosing: true,
      }
    case actionTypes.SET_DRAWER_CLOSED:
      return {
        ...state,
        isDrawerClosing: false,
        isDrawerClosed: true,
      }
    case actionTypes.SET_DRAWER_VISIBLE:
      return {
        ...state,
        ...(not(payload) && {
          showDrawerMask: false,
          isDrawerClosed: true,
          isDrawerOpened: false,
        }),
        isDrawerVisible: payload,
      }
    case actionTypes.SET_SHOW_DRAWER_MASK:
      return {
        ...state,
        showDrawerMask: payload,
      }
    case actionTypes.SET_DRAWER_WIDTH:
      return {
        ...state,
        drawerWidth: payload,
      }
    default:
      throw new Error()
  }
}

export { withDrawerProvider, DrawerContext }
